import React, { Component } from 'react';
import PropTypes from 'prop-types';
import apiFetch from 'utils/apiFetch';
import _ from 'lodash';
import SwipeableCards from 'components/Steps/SwipeableCards';
import Navbar from 'components/Navbar';
import { ROUTE_MAIN_PAGE } from 'constants/urls';
import {
  CardWrapper, UserProfilesWrapper,
} from './styles';

class UsersProfiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: null,
    };
  }

  componentDidMount() {
    const {
      match: { params: { id } },
      setBreadcrumb,
      literals,
    } = this.props;
    apiFetch('GET', { endPoint: `recommendations/users/${id}` })
      .then(({ users }) => {
        this.setState({ users });
      });

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.recommendations,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  handleEnd = () => {
    const { goHome, history, resetContext } = this.props;
    resetContext();
    goHome();
    history.push(ROUTE_MAIN_PAGE);
  }

  render() {
    const { literals, app: { color1: color } } = this.props;
    const { users } = this.state;
    if (!users) {
      return null;
    }

    return (
      <UserProfilesWrapper color={color}>
        <Navbar />
        <CardWrapper>
          <SwipeableCards
            title={literals.weFoundTheseUsers}
            users={_.map(users, ({ id }) => id)}
            onEnd={this.handleEnd}
          />
        </CardWrapper>
      </UserProfilesWrapper>
    );
  }
}

UsersProfiles.propTypes = {
  literals: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  goHome: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  resetContext: PropTypes.func.isRequired,
};


export default UsersProfiles;



// WEBPACK FOOTER //
// ./src/routes/UsersProfiles/components/UsersProfiles.jsx